import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-agent-field-note',
  standalone: true,
  styleUrl: './agent-field-note.component.scss',
  templateUrl: './agent-field-note.component.html',
})
export class AgentFieldNoteComponent {
  readonly surface = input<'dark' | 'light'>('dark');
  readonly variant = input<'data-schema' | 'prompt' | 'ui-template'>('ui-template');
}
